$(document).click(function(){
	$('.choose-city').removeClass('active')
});

$('.choose-city').click(function(e){

	e.stopPropagation();

	$(this).toggleClass('active');
});

$('.choose-city a').click(function(e){
	let choose = $('.choose-city');
	let output = choose.find('.output');
	let parent = $(this).parent('li');

	if($(this).attr('href') == '#'){
		e.preventDefault();

		$('.choose-city .active').removeClass('active');
		parent.addClass('active');
		output.text($(this).text())
	}
})